export default __webpack_public_path__ + "static/media/medium-icon.0f62ee44.png";